const theme = {
    palette: {
      primary: {
        main: '#424242',
        contrastText: '#fff',
      },
    },
    typography: {
      fontFamily: "monospace",
    }
  };
  
  export default theme;
  